export default "__VITE_ASSET__EE0gZnIa__"